"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBTimeNegative = function SvgBTimeNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M92.392 93.832a2.107 2.107 0 01-1.49-.618L75.45 77.795a2.107 2.107 0 112.978-2.978L93.881 90.27a2.107 2.107 0 01-1.496 3.597l.007-.035z"
  }), (0, _core.jsx)("path", {
    d: "M72.351 143.298a71.326 71.326 0 01-56.104-27.08 2.11 2.11 0 013.302-2.627c22.371 28.108 62.914 33.604 91.96 12.465 29.047-21.138 36.286-61.407 16.419-91.338-19.867-29.93-59.786-38.898-90.545-20.34C6.623 32.934-4.057 72.43 13.157 103.96a2.107 2.107 0 11-3.695 2.023C-6.002 77.661-.624 42.495 22.598 20.088 45.82-2.318 81.155-6.436 108.908 10.03c27.752 16.466 41.073 49.452 32.536 80.572-8.536 31.12-36.823 52.694-69.093 52.696z"
  }), (0, _core.jsx)("path", {
    d: "M72.351 130.295c-24.872-.031-47.01-15.77-55.212-39.25-8.202-23.482-.677-49.582 18.767-65.092 19.443-15.51 46.562-17.047 67.634-3.833a2.108 2.108 0 11-2.234 3.575C79.17 11.822 50.298 15.662 32.558 34.837c-17.74 19.176-19.325 48.26-3.775 69.25 15.55 20.99 43.836 27.946 67.347 16.56 23.512-11.384 35.595-37.888 28.77-63.103a56.034 56.034 0 00-12.46-22.57L78.56 68.84a2.107 2.107 0 01-2.978-2.978l35.403-35.41a2.107 2.107 0 012.978 0 60.199 60.199 0 0115.005 25.99c8.443 31.213-10.009 63.363-41.22 71.817a58.963 58.963 0 01-15.397 2.037z"
  }), (0, _core.jsx)("path", {
    d: "M72.45 79.93a8.212 8.212 0 01-6.26-13.528l.457-.513c.07-.07.14-.14.218-.204l.45-.372h.042a8.212 8.212 0 116.483 14.533c-.46.07-.925.098-1.39.085zM69.682 68.84l-.316.351a3.934 3.934 0 00-.85 3.217 4.004 4.004 0 007.207 1.637c.626-.86.88-1.936.702-2.985a4.004 4.004 0 00-4.615-3.274c-.654.11-1.27.383-1.79.794l-.338.26zM72.47 30.725a2.107 2.107 0 01-2.107-2.108v-3.33a2.107 2.107 0 114.215 0v3.33a2.107 2.107 0 01-2.107 2.108zM72.47 120.377a2.107 2.107 0 01-2.107-2.107v-3.33a2.107 2.107 0 114.215 0v3.33a2.107 2.107 0 01-2.107 2.107zM118.965 73.89h-3.33a2.107 2.107 0 010-4.215h3.33a2.107 2.107 0 010 4.215zM29.313 73.89H25.99a2.107 2.107 0 110-4.215h3.33a2.107 2.107 0 110 4.215h-.007z"
  })));
};

var _default = SvgBTimeNegative;
exports["default"] = _default;